module.exports = __webpack_public_path__ + "static/media/GTBSAnimated.6ebe6462.gif";